import { GeolocateControl } from 'maplibre-gl'

import { gettext } from '@bikemap/js/services'
import { setTooltip } from '@bikemap/js/utility'
import MapFeature from './MapFeature'

/**
 * Let the users locate themselves on the map.
 */
export default class Geolocation extends MapFeature {

    /** @type {GeolocateControl} */
    _geolocateControl

    constructor() {
        super()

        this._geolocateControl = new GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true,
            },
            trackUserLocation: false,
        })
    }

    _onAdd(map) {
        map.addControl(this._geolocateControl, 'top-left')
        setTooltip('.maplibregl-ctrl-top-left .maplibregl-ctrl-group', gettext('Geolocate'))
    }

    _onRemove(map) {
        map.removeControl(this._geolocateControl)
    }

}
